import React from 'react'
import Divider from "../common/Divider";
import {Link} from "react-router-dom";

function PrivacyLinks() {

    const styleLink = { textDecoration: 'none' };
    const pagatUrl = 'https://www.pagat.com/jass/29.html';

    return <div className="row justify-content-around">
        <Divider />
        <a href={pagatUrl} target="_blank" rel="noreferrer" style={styleLink}>📃 Rules</a>
        <Divider />
        <Link to={'/privacy-policy'} style={styleLink}>🔒  Privacy Policy </Link>
        <Divider />
        <Link to={'/privacy'} style={{ textDecoration: 'none' }}>🕹 Data Removal Consent </Link>
        <Divider />
        <Link to={'/terms-of-service'} style={{ textDecoration: 'none' }}>🧸 Terms and conditions</Link>
    </div>
}

export default React.memo(PrivacyLinks)
